import React, { useState, useEffect } from 'react';
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const EditInstitute = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState({
        country_name: '',
        country_code: '',
        institute_name: '',
        campus: '',
        website: '',
        international_contact_person: '',
        email: '',
        contact_no: '',
        status: true,
        institute_logo: ''
    });
    const [logo, setLogo] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            fetchInstitute();
        }
    }, [id]);

    const fetchInstitute = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`https://bmrbackend.dynastymaker.com/api/institutes/${id}`);
            const instituteData = response.data.data;
            
            setFormData({
                country_name: instituteData.country_name || '',
                country_code: instituteData.country_code || '',
                institute_name: instituteData.institute_name || '',
                campus: instituteData.campus || '',
                website: instituteData.website || '',
                international_contact_person: instituteData.international_contact_person || '',
                email: instituteData.email || '',
                contact_no: instituteData.contact_no || '',
                status: instituteData.status || true,
                institute_logo: instituteData.institute_logo || ''
            });
            
            setLoading(false);
        } catch (error) {
            console.error('Error fetching institute:', error);
            toast.error('Failed to fetch institute data');
            setLoading(false);
        }
    };

 const countries = [
  { "name": "Afghanistan", "code": "AF" },
  { "name": "Åland Islands", "code": "AX" },
  { "name": "Albania", "code": "AL" },
  { "name": "Algeria", "code": "DZ" },
  { "name": "American Samoa", "code": "AS" },
  { "name": "Andorra", "code": "AD" },
  { "name": "Angola", "code": "AO" },
  { "name": "Anguilla", "code": "AI" },
  { "name": "Antarctica", "code": "AQ" },
  { "name": "Antigua and Barbuda", "code": "AG" },
  { "name": "Argentina", "code": "AR" },
  { "name": "Armenia", "code": "AM" },
  { "name": "Aruba", "code": "AW" },
  { "name": "Australia", "code": "AU" },
  { "name": "Austria", "code": "AT" },
  { "name": "Azerbaijan", "code": "AZ" },
  { "name": "Bahamas", "code": "BS" },
  { "name": "Bahrain", "code": "BH" },
  { "name": "Bangladesh", "code": "BD" },
  { "name": "Barbados", "code": "BB" },
  { "name": "Belarus", "code": "BY" },
  { "name": "Belgium", "code": "BE" },
  { "name": "Belize", "code": "BZ" },
  { "name": "Benin", "code": "BJ" },
  { "name": "Bermuda", "code": "BM" },
  { "name": "Bhutan", "code": "BT" },
  { "name": "Bolivia (Plurinational State of)", "code": "BO" },
  { "name": "Bonaire, Sint Eustatius and Saba", "code": "BQ" },
  { "name": "Bosnia and Herzegovina", "code": "BA" },
  { "name": "Botswana", "code": "BW" },
  { "name": "Bouvet Island", "code": "BV" },
  { "name": "Brazil", "code": "BR" },
  { "name": "British Indian Ocean Territory", "code": "IO" },
  { "name": "Brunei Darussalam", "code": "BN" },
  { "name": "Bulgaria", "code": "BG" },
  { "name": "Burkina Faso", "code": "BF" },
  { "name": "Burundi", "code": "BI" },
  { "name": "Cabo Verde", "code": "CV" },
  { "name": "Cambodia", "code": "KH" },
  { "name": "Cameroon", "code": "CM" },
  { "name": "Canada", "code": "CA" },
  { "name": "Cayman Islands", "code": "KY" },
  { "name": "Central African Republic", "code": "CF" },
  { "name": "Chad", "code": "TD" },
  { "name": "Chile", "code": "CL" },
  { "name": "China", "code": "CN" },
  { "name": "Christmas Island", "code": "CX" },
  { "name": "Cocos (Keeling) Islands", "code": "CC" },
  { "name": "Colombia", "code": "CO" },
  { "name": "Comoros", "code": "KM" },
  { "name": "Congo", "code": "CG" },
  { "name": "Congo (Democratic Republic of the)", "code": "CD" },
  { "name": "Cook Islands", "code": "CK" },
  { "name": "Costa Rica", "code": "CR" },
  { "name": "Côte d'Ivoire", "code": "CI" },
  { "name": "Croatia", "code": "HR" },
  { "name": "Cuba", "code": "CU" },
  { "name": "Curaçao", "code": "CW" },
  { "name": "Cyprus", "code": "CY" },
  { "name": "Czech Republic", "code": "CZ" },
  { "name": "Denmark", "code": "DK" },
  { "name": "Djibouti", "code": "DJ" },
  { "name": "Dominica", "code": "DM" },
  { "name": "Dominican Republic", "code": "DO" },
  { "name": "Ecuador", "code": "EC" },
  { "name": "Egypt", "code": "EG" },
  { "name": "El Salvador", "code": "SV" },
  { "name": "Equatorial Guinea", "code": "GQ" },
  { "name": "Eritrea", "code": "ER" },
  { "name": "Estonia", "code": "EE" },
  { "name": "Eswatini", "code": "SZ" },
  { "name": "Ethiopia", "code": "ET" },
  { "name": "Falkland Islands (Malvinas)", "code": "FK" },
  { "name": "Faroe Islands", "code": "FO" },
  { "name": "Fiji", "code": "FJ" },
  { "name": "Finland", "code": "FI" },
  { "name": "France", "code": "FR" },
  { "name": "French Guiana", "code": "GF" },
  { "name": "French Polynesia", "code": "PF" },
  { "name": "French Southern Territories", "code": "TF" },
  { "name": "Gabon", "code": "GA" },
  { "name": "Gambia", "code": "GM" },
  { "name": "Georgia", "code": "GE" },
  { "name": "Germany", "code": "DE" },
  { "name": "Ghana", "code": "GH" },
  { "name": "Gibraltar", "code": "GI" },
  { "name": "Greece", "code": "GR" },
  { "name": "Greenland", "code": "GL" },
  { "name": "Grenada", "code": "GD" },
  { "name": "Guadeloupe", "code": "GP" },
  { "name": "Guam", "code": "GU" },
  { "name": "Guatemala", "code": "GT" },
  { "name": "Guernsey", "code": "GG" },
  { "name": "Guinea", "code": "GN" },
  { "name": "Guinea-Bissau", "code": "GW" },
  { "name": "Guyana", "code": "GY" },
  { "name": "Haiti", "code": "HT" },
  { "name": "Heard Island and McDonald Islands", "code": "HM" },
  { "name": "Holy See", "code": "VA" },
  { "name": "Honduras", "code": "HN" },
  { "name": "Hong Kong", "code": "HK" },
  { "name": "Hungary", "code": "HU" },
  { "name": "Iceland", "code": "IS" },
  { "name": "India", "code": "IN" },
  { "name": "Indonesia", "code": "ID" },
  { "name": "Iran (Islamic Republic of)", "code": "IR" },
  { "name": "Iraq", "code": "IQ" },
  { "name": "Ireland", "code": "IE" },
  { "name": "Isle of Man", "code": "IM" },
  { "name": "Israel", "code": "IL" },
  { "name": "Italy", "code": "IT" },
  { "name": "Jamaica", "code": "JM" },
  { "name": "Japan", "code": "JP" },
  { "name": "Jersey", "code": "JE" },
  { "name": "Jordan", "code": "JO" },
  { "name": "Kazakhstan", "code": "KZ" },
  { "name": "Kenya", "code": "KE" },
  { "name": "Kiribati", "code": "KI" },
  { "name": "Korea (Democratic People's Republic of)", "code": "KP" },
  { "name": "Korea (Republic of)", "code": "KR" },
  { "name": "Kuwait", "code": "KW" },
  { "name": "Kyrgyzstan", "code": "KG" },
  { "name": "Lao People's Democratic Republic", "code": "LA" },
  { "name": "Latvia", "code": "LV" },
  { "name": "Lebanon", "code": "LB" },
  { "name": "Lesotho", "code": "LS" },
  { "name": "Liberia", "code": "LR" },
  { "name": "Libya", "code": "LY" },
  { "name": "Liechtenstein", "code": "LI" },
  { "name": "Lithuania", "code": "LT" },
  { "name": "Luxembourg", "code": "LU" },
  { "name": "Macao", "code": "MO" },
  { "name": "Madagascar", "code": "MG" },
  { "name": "Malawi", "code": "MW" },
  { "name": "Malaysia", "code": "MY" },
  { "name": "Maldives", "code": "MV" },
  { "name": "Mali", "code": "ML" },
  { "name": "Malta", "code": "MT" },
  { "name": "Marshall Islands", "code": "MH" },
  { "name": "Martinique", "code": "MQ" },
  { "name": "Mauritania", "code": "MR" },
  { "name": "Mauritius", "code": "MU" },
  { "name": "Mayotte", "code": "YT" },
  { "name": "Mexico", "code": "MX" },
  { "name": "Micronesia (Federated States of)", "code": "FM" },
  { "name": "Moldova (Republic of)", "code": "MD" },
  { "name": "Monaco", "code": "MC" },
  { "name": "Mongolia", "code": "MN" },
  { "name": "Montenegro", "code": "ME" },
  { "name": "Montserrat", "code": "MS" },
  { "name": "Morocco", "code": "MA" },
  { "name": "Mozambique", "code": "MZ" },
  { "name": "Myanmar", "code": "MM" },
  { "name": "Namibia", "code": "NA" },
  { "name": "Nauru", "code": "NR" },
  { "name": "Nepal", "code": "NP" },
  { "name": "Netherlands", "code": "NL" },
  { "name": "New Caledonia", "code": "NC" },
  { "name": "New Zealand", "code": "NZ" },
  { "name": "Nicaragua", "code": "NI" },
  { "name": "Niger", "code": "NE" },
  { "name": "Nigeria", "code": "NG" },
  { "name": "Niue", "code": "NU" },
  { "name": "Norfolk Island", "code": "NF" },
  { "name": "North Macedonia", "code": "MK" },
  { "name": "Northern Mariana Islands", "code": "MP" },
  { "name": "Norway", "code": "NO" },
  { "name": "Oman", "code": "OM" },
  { "name": "Pakistan", "code": "PK" },
  { "name": "Palau", "code": "PW" },
  { "name": "Palestine, State of", "code": "PS" },
  { "name": "Panama", "code": "PA" },
  { "name": "Papua New Guinea", "code": "PG" },
  { "name": "Paraguay", "code": "PY" },
  { "name": "Peru", "code": "PE" },
  { "name": "Philippines", "code": "PH" },
  { "name": "Pitcairn", "code": "PN" },
  { "name": "Poland", "code": "PL" },
  { "name": "Portugal", "code": "PT" },
  { "name": "Puerto Rico", "code": "PR" },
  { "name": "Qatar", "code": "QA" },
  { "name": "Réunion", "code": "RE" },
  { "name": "Romania", "code": "RO" },
  { "name": "Russian Federation", "code": "RU" },
  { "name": "Rwanda", "code": "RW" },
  { "name": "Saint Barthélemy", "code": "BL" },
  { "name": "Saint Helena, Ascension and Tristan da Cunha", "code": "SH" },
  { "name": "Saint Kitts and Nevis", "code": "KN" },
  { "name": "Saint Lucia", "code": "LC" },
  { "name": "Saint Martin (French part)", "code": "MF" },
  { "name": "Saint Pierre and Miquelon", "code": "PM" },
  { "name": "Saint Vincent and the Grenadines", "code": "VC" },
  { "name": "Samoa", "code": "WS" },
  { "name": "San Marino", "code": "SM" },
  { "name": "Sao Tome and Principe", "code": "ST" },
  { "name": "Saudi Arabia", "code": "SA" },
  { "name": "Senegal", "code": "SN" },
  { "name": "Serbia", "code": "RS" },
  { "name": "Seychelles", "code": "SC" },
  { "name": "Sierra Leone", "code": "SL" },
  { "name": "Singapore", "code": "SG" },
  { "name": "Sint Maarten (Dutch part)", "code": "SX" },
  { "name": "Slovakia", "code": "SK" },
  { "name": "Slovenia", "code": "SI" },
  { "name": "Solomon Islands", "code": "SB" },
  { "name": "Somalia", "code": "SO" },
  { "name": "South Africa", "code": "ZA" },
  { "name": "South Georgia and the South Sandwich Islands", "code": "GS" },
  { "name": "South Sudan", "code": "SS" },
  { "name": "Spain", "code": "ES" },
  { "name": "Sri Lanka", "code": "LK" },
  { "name": "Sudan", "code": "SD" },
  { "name": "Suriname", "code": "SR" },
  { "name": "Svalbard and Jan Mayen", "code": "SJ" },
  { "name": "Sweden", "code": "SE" },
  { "name": "Switzerland", "code": "CH" },
  { "name": "Syrian Arab Republic", "code": "SY" },
  { "name": "Taiwan", "code": "TW" },
  { "name": "Tajikistan", "code": "TJ" },
  { "name": "Tanzania, United Republic of", "code": "TZ" },
  { "name": "Thailand", "code": "TH" },
  { "name": "Timor-Leste", "code": "TL" },
  { "name": "Togo", "code": "TG" },
  { "name": "Tokelau", "code": "TK" },
  { "name": "Tonga", "code": "TO" },
  { "name": "Trinidad and Tobago", "code": "TT" },
  { "name": "Tunisia", "code": "TN" },
  { "name": "Turkey", "code": "TR" },
  { "name": "Turkmenistan", "code": "TM" },
  { "name": "Turks and Caicos Islands", "code": "TC" },
  { "name": "Tuvalu", "code": "TV" },
  { "name": "Uganda", "code": "UG" },
  { "name": "Ukraine", "code": "UA" },
  { "name": "United Arab Emirates", "code": "AE" },
  { "name": "United Kingdom of Great Britain and Northern Ireland", "code": "GB" },
  { "name": "United States of America", "code": "US" },
  { "name": "United States Minor Outlying Islands", "code": "UM" },
  { "name": "Uruguay", "code": "UY" },
  { "name": "Uzbekistan", "code": "UZ" },
  { "name": "Vanuatu", "code": "VU" },
  { "name": "Venezuela (Bolivarian Republic of)", "code": "VE" },
  { "name": "Viet Nam", "code": "VN" },
  { "name": "Virgin Islands (British)", "code": "VG" },
  { "name": "Virgin Islands (U.S.)", "code": "VI" },
  { "name": "Wallis and Futuna", "code": "WF" },
  { "name": "Western Sahara", "code": "EH" },
  { "name": "Yemen", "code": "YE" },
  { "name": "Zambia", "code": "ZM" },
  { "name": "Zimbabwe", "code": "ZW" }
];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCountryChange = (e) => {
        const selectedCode = e.target.value;
        const selectedCountry = countries.find(c => c.code === selectedCode);
        
        if (selectedCountry) {
            setFormData({
                ...formData,
                country_name: selectedCountry.name,
                country_code: selectedCountry.code
            });
        }
    };

    const handleLogoChange = (e) => {
        setLogo(e.target.files[0]);
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
       const formDataToSend = new FormData();
formDataToSend.append('country_name', formData.country_name);
formDataToSend.append('country_code', formData.country_code);
formDataToSend.append('institute_name', formData.institute_name);
formDataToSend.append('campus', formData.campus);
formDataToSend.append('website', formData.website);
formDataToSend.append('international_contact_person', formData.international_contact_person);
formDataToSend.append('email', formData.email);
formDataToSend.append('contact_no', formData.contact_no);
formDataToSend.append('status', formData.status ? '1' : '0');
formDataToSend.append('_method', 'PUT'); // Spoof PUT method

if (logo) {
  formDataToSend.append('institute_logo', logo);
}


        const response = await axios.post(`https://bmrbackend.dynastymaker.com/api/institutes/${id}`,
  formDataToSend,
  {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  }
);

        toast.success('Institute updated successfully!');
        fetchInstitute(); // Refresh data
        
    } catch (error) {
        console.error('Update error:', error);
        let errorMessage = 'Failed to update institute';
        
        if (error.response?.data?.errors) {
            errorMessage = Object.values(error.response.data.errors)
                                .flat()
                                .join('\n');
        } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        }
        
        toast.error(errorMessage);
    } finally {
        setLoading(false);
    }
};

    return (
        <div className="container py-4">
            <div className='d-flex align-items-center justify-content-center'>
                <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
                    Edit INSTITUTE
                </div>
            </div>
            
            {loading ? (
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <div className="mb-3">
                                <label>Select Country *</label>
                                <div className='border px-2 rounded' style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <img
                                        src={`https://flagsapi.com/${formData.country_code}/flat/32.png`}
                                        alt="flag"
                                        style={{ width: '32px', height: '24px' }}
                                        onError={(e) => {
                                            e.target.onerror = null; 
                                            e.target.src = 'https://flagsapi.com/US/flat/32.png';
                                        }}
                                    />
                                    <select
                                        className="form-select border-0 no-border-select"
                                        name="country_code"
                                        value={formData.country_code}
                                        onChange={handleCountryChange}
                                        required
                                    >
                                        <option value="">Select a country</option>
                                        {countries.map((country) => (
                                            <option key={country.code} value={country.code}>
                                                {country.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            
                            <div className="mb-3">
                                <label>Institute Name *</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="institute_name"
                                    value={formData.institute_name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            
                            <div className="mb-3">
                                <label>Campus *</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="campus"
                                    value={formData.campus}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            
                            <div className="mb-3">
                                <label>Website *</label>
                                <input 
                                    type="url" 
                                    className="form-control" 
                                    name="website"
                                    value={formData.website}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            
                            <div className="mb-3">
                                <label>Institute Logo</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    className="form-control"
                                    onChange={handleLogoChange}
                                />
                                {formData.institute_logo && !logo && (
                                    <div className="mt-2">
                                        <small>Current logo:</small>
                                        <img 
                                            src={`https://bmrbackend.dynastymaker.com/storage/app/public/${formData.institute_logo}`} 
                                            alt="Institute logo" 
                                            style={{ maxWidth: '200px', maxHeight: '200px', display: 'block' }}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='d-flex align-items-center justify-content-center'>
                        <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
                            Personal Details
                        </div>
                    </div>
                    
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <div className="mb-3">
                                <label>International Contact Person *</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="international_contact_person"
                                    value={formData.international_contact_person}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            
                            <div className="mb-3">
                                <label>E-mail *</label>
                                <input 
                                    type="email" 
                                    className="form-control" 
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            
                            <div className="mb-3">
                                <label>Contact No *</label>
                                <input 
                                    type="tel" 
                                    className="form-control" 
                                    name="contact_no"
                                    value={formData.contact_no}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="d-flex justify-content-end gap-2 pt-3 pb-3">
                                <button 
                                    type="submit" 
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? 'Updating...' : 'Update Institute'}
                                </button>
                            </div>

                            <div className="mt-3">
                                <Link to={'/super-admin/institute'} type="button" className="btn bg-light buttonadd">
                                    <IoArrowUndoSharp size={20} /> Back
                                </Link>
                            </div>
                        </div>
                    </div>
                </form>
            )}
        </div>
    );
};

export default EditInstitute;